import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RESOURCES } from 'OpsCenter/app.constants';

@Injectable()
export class CustomerImportService {
  constructor(private http: HttpClient) {}

  uploadFile(merchantId: number, file: File) {
    const formData: FormData = new FormData();
    formData.append('attachment', file, file.name);
    const headers = new HttpHeaders().set('X-Quandoo-ApiVersion', '2');

    return this.http.post(`${RESOURCES.MERCHANT}/${merchantId}/import_csv`, formData, { headers });
  }
}



// WEBPACK FOOTER //
// ./src/app/merchants/importing/customers/customer-import.service.ts